import React from 'react';
import { translate } from '../../base/i18n/functions';
import { DeviceSelection, _translate } from './DeviceSelection';
import VideoQualitySlider from '../../video-quality/components/VideoQualitySlider';
import AudioInputPreview from './AudioInputPreview';
import AudioOutputPreview from './AudioOutputPreview';
import VideoInputPreview from './VideoInputPreview';
import { IconMicrophone, IconVolume } from '../../base/icons';

class RPC_DeviceSelection extends DeviceSelection {
    constructor(props) {
        super(props);
    }

    render () {
        const {
            hideAudioInputPreview,
            hideAudioOutputSelect,
            selectedAudioOutputId
        } = this.props;
        return <>
            <div className = 'device-selection'>
                <div className = 'device-selection-column column-video'>
                    <div className = 'device-selection-video-container'>
                        <VideoInputPreview
                            error = { this.state.previewVideoTrackError }
                            track = { this.state.previewVideoTrack } />
                    </div>
                    { !hideAudioInputPreview
                        && <div><IconMicrophone /> <AudioInputPreview
                            track = { this.state.previewAudioTrack } /></div> }
                    { !hideAudioOutputSelect
                        && <div><IconVolume /> <AudioOutputPreview
                            deviceId = { selectedAudioOutputId } /></div> }
                </div>
                <div className = 'device-selection-column column-selectors'>
                    <div className = 'device-selectors'>
                        { this._renderSelectors() }
                    </div>
                </div>
            </div>
            <br />
            <span style={{fontSize: '14px', color: '#1896c6', fontWeight: '600'}}>Video Quality</span>
            <VideoQualitySlider />
        </>
    }
}

export default translate(RPC_DeviceSelection);